// https://github.com/pimterry/loglevel
import log from 'loglevel';
import prefix from 'loglevel-plugin-prefix';

import { useEnvironment } from '@/composables/useEnvironment';
const { isPrd } = useEnvironment();

export default (_, inject) => {
  prefix.reg(log);
  log.enableAll();
  log.setDefaultLevel('DEBUG');

  const levelConfig = !isPrd ? log.levels.DEBUG : log.levels.WARN; // eslint-disable-line
  log.setLevel(levelConfig, false);

  prefix.apply(log, {
    template: '[%t] %l (%n):',
    levelFormatter(level) {
      return level.toUpperCase();
    },
    nameFormatter(name) {
      return name || 'global';
    },
    timestampFormatter(date) {
      return date.toLocaleString('ja');
    }
  });

  inject('log', log);
};
